<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <div>
                            <h3 class="card-title mb-0">
                                <i class="fas fa-ticket-alt tw:mr-2" aria-hidden="true"></i>
                                Precios
                            </h3>
                            <p class="card-text tw:mt-2 tw:mb-0 tw:text-sm tw:text-gray-600">
                                Configura los precios y la disponibilidad de entradas para esta sesión.
                            </p>
                        </div>
                        <div>
                            <Button @click.prevent="showModal('crearEntrada')">Crear nueva entrada</Button>
                            <CreateModal
                                :sesion="sesion"
                                :evento_id="evento_id"
                                v-on:close="closeModal"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card-body">
                <div
                    v-if="sesion.stock_compartido === true"
                    class="tw:mb-4 tw:flex tw:flex-col tw:gap-5 tw:rounded-xl tw:border tw:border-blue-200 tw:border-l-4 tw:border-l-blue-500 tw:bg-gradient-to-br tw:from-blue-50 tw:to-slate-50 tw:p-5 tw:text-slate-800 tw:shadow-md tw:lg:flex-row"
                    role="status"
                    aria-live="polite"
                    data-cy="shared-stock-banner"
                >
                    <div class="tw:flex tw:items-start tw:gap-3 tw:lg:flex-1">
                        <span class="tw:flex tw:h-11 tw:w-11 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-xl tw:bg-blue-500 tw:text-white tw:shadow-md" aria-hidden="true">
                            <i class="fas fa-layer-group"></i>
                        </span>
                        <div>
                            <span class="tw:mb-1 tw:block tw:text-[11px] tw:font-bold tw:uppercase tw:tracking-[0.08em] tw:text-blue-600">Stock compartido</span>
                            <h4 class="tw:mb-0 tw:text-lg tw:font-bold tw:text-slate-900">Resumen de la sesión</h4>
                            <p class="tw:mt-1 tw:mb-0 tw:text-sm tw:text-slate-600">
                                Un único cupo se comparte entre todos los precios y entradas.
                            </p>
                        </div>
                    </div>
                    <div class="tw:grid tw:min-w-0 tw:grid-cols-1 tw:gap-3 tw:sm:grid-cols-2 tw:lg:flex-1 tw:lg:grid-cols-3">
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-blue-200 tw:bg-white tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Cupo total de la sesión: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-slate-900">{{ sesion.cupo_total }}</strong>
                            </span>
                        </div>
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-emerald-200 tw:bg-emerald-50 tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Cupo disponible: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-emerald-900">{{ sesion.cupo_disponible }}</strong>
                            </span>
                        </div>
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-amber-200 tw:bg-amber-50 tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Entradas activas: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-amber-900">{{ sesion.entradas_activas }}</strong>
                            </span>
                            <small class="tw:mt-1 tw:text-[11px] tw:text-amber-700">(vendidas + en sesión)</small>
                        </div>
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-slate-200 tw:bg-white/70 tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Entradas vendidas: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-slate-900">{{ sesion.entradas_vendidas }}</strong>
                            </span>
                        </div>
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-slate-200 tw:bg-white/70 tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Entradas en sesión: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-slate-900">{{ sesion.entradas_en_sesion }}</strong>
                            </span>
                        </div>
                        <div class="tw:flex tw:min-h-[4.25rem] tw:flex-col tw:justify-center tw:rounded-lg tw:border tw:border-slate-200 tw:bg-white/70 tw:px-3 tw:py-3 tw:shadow-sm">
                            <span class="tw:text-xs tw:leading-snug tw:text-slate-600">
                                Entradas reservadas: <strong class="tw:mt-1 tw:block tw:text-2xl tw:font-black tw:leading-none tw:text-slate-900">{{ sesion.entradas_reservadas }}</strong>
                            </span>
                        </div>
                    </div>
                </div>
                <draggable v-model="entradas" group="entradas" @end="onDragEnd" :delay="200">
                    <div v-for="(entrada) in entradas" :key="entrada.id" class="row mb-4 draggable-item" :data-cy="'entrada-row-' + entrada.id">
                        <div :key="entrada.id + '_'" class="col-12 col-md-10">
                            <template v-if="entrada.descripcion != 'Invitación Protocolo'">
                                <h4><strong>{{ entrada.descripcion }}</strong></h4>
                                <div class="row">
                                    <div v-if="sesion.stock_compartido !== true" class="col-6 col-md-4" data-cy="entry-stock-counters">
                                        Entradas: {{ entrada.units }} <br />
                                        En sesión: {{ entrada.en_sesion }} <br />
                                        Reservadas: {{ entrada.reservadas }} <br />
                                        Disponibles: {{ entrada.disponibles }}
                                    </div>
                                    <div class="col-6 col-md-4">
                                        Online: {{ entrada.price_management_online_interno == 1 ? parseFloat(entrada.precio) : parseFloat(entrada.precio) + parseFloat(entrada.price_management_online) | formatear_precio }} <br />
                                        Taquilla: {{ entrada.price_management_taquilla_interno == 1 ? parseFloat(entrada.precio) : parseFloat(entrada.precio) + parseFloat(entrada.price_management_taquilla) | formatear_precio }}
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div :key="entrada.id" class="col-12 col-md-2">
                            <div class="text-right">
                                <div>
                                    <OpcionesDropdownTableComponent 
                                        :data-cy="'entrada-opciones-' + entrada.id"
                                        v-bind:options="[
                                            {
                                                type: 'action',
                                                action: () => showModal('editarEntrada-' + entrada.id, entrada),
                                                label: 'Editar',
                                            },
                                            {
                                                type: 'action',
                                                action: () => showModal('editarEntradaPuertas-' + entrada.id, entrada),
                                                label: 'Puertas',
                                            },
                                            {
                                                type: 'action',
                                                action: () => showModal('deleteEntrada-' + entrada.id, entrada),
                                                label: 'Borrar',
                                            },    
                                        ]" 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
                <EditarModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion="sesion" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <BorrarModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion_id="sesion.id" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <PuertasModal v-if="entradaSeleccionada" :evento_id="evento_id" :sesion_id="sesion.id" :entrada="entradaSeleccionada" v-on:close="closeModal"/>
                <div v-if="guardar_orden" class="text-right">
                    <button type="button" class="btn btn-primary" @click="updateOrdenEntradas()">GUARDAR ORDEN</button>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="card-body">
                <LoaderComponent/>
            </div>
        </template>
    </div>
</template>

<script setup>
    import { getCurrentInstance, nextTick, onMounted, ref } from 'vue'
    import draggable from 'vuedraggable'

    import CreateModal from '@/views/backend/events/sesiones/sinrecinto/modals/CreateEntradaSinRecinto'
    import EditarModal from '@/views/backend/events/sesiones/sinrecinto/modals/EditarEntradaSinRecinto'
    import BorrarModal from '@/views/backend/events/sesiones/sinrecinto/modals/DeleteEntradaSinRecinto'
    import PuertasModal from '@/views/backend/events/sesiones/sinrecinto/modals/PuertasModal'
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent.vue'

    const props = defineProps({
        evento_id: {
            type: [Number, String],
            required: true
        },
        sesion_id: {
            type: [Number, String],
            required: true
        }
    })

    const instance = getCurrentInstance()
    const store = instance.proxy.$store
    const modal = instance.proxy.$modal
    const toast = instance.proxy.$toast
    const config = instance.proxy.config

    const expand = ref([])
    const sesion = ref(null)
    const entradas = ref([])
    const loading = ref(true)
    const guardar_orden = ref(false)
    const entradaSeleccionada = ref(null)

    function showModal(modalName, entrada) {
        entradaSeleccionada.value = entrada

        nextTick(() => {
            modal.show(modalName)
        })
    }

    function closeModal(modalName, creado) {
        expand.value = []

        if (creado) {
            getSesion()
        }

        modal.hide(modalName)
    }

    function getSesion() {
        loading.value = true

        const params = {
            filters: {},
            evento_id: props.evento_id,
            sesion_id: props.sesion_id
        }

        store.dispatch(config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
            sesion.value = res.data.data
            entradas.value = res.data.data.entradas
        }).finally(() => {
            loading.value = false
        })
    }

    function onDragEnd() {
        guardar_orden.value = true
    }

    function updateOrdenEntradas() {
        const params = {
            filters: {},
            evento_id: props.evento_id,
            sesion_id: props.sesion_id,
            entradas: entradas.value
        }

        store.dispatch(config.getVuexAlias('back.events.sesiones.tickets.editar-orden'), params).then(res => {
            toast.success(res.data.message)
            getSesion()
            guardar_orden.value = false
        })
    }

    onMounted(() => {
        getSesion()
    })
</script>

<style scoped>
    .draggable-item {
        transition: background-color 0.3s;
    }

    .draggable-item:active {
        background-color: #f0f0f0;
    }

    .draggable-item:hover {
        cursor: grab;
    }

    .drag-handle {
        cursor: pointer;
    }
</style>
